// @flow
import React from 'react';
import MetaLinkRenderer from './JobListItem/MetaLinkRenderer/MetaLinkRenderer';

export function model(job: SearchResultJob): JobViewModelItemPartial {
  if (job.companyName) {
    return {
      title: `Jobs at ${job.companyName}`,
      name: job.advertiser.description || '', // Yes, the adv. desc.
      params: { keywords: job.companyName }
    };
  }

  return {
    title: `Jobs at ${job.advertiser.description || ''}`,
    name: job.advertiser.description || '',
    params: { advertiserid: job.advertiser.id }
  };
}

export function CompanyLink({ job }: { job: SearchResultJob }) {
  return job.isPrivateAdvertiser ? (
    <span>{model(job).name}</span>
  ) : (
    <MetaLinkRenderer item={model(job)} type="company" />
  );
}
